import { Link } from 'react-router-dom';
import MarketingNav from '../components/MarketingNav';

const SUPPORT_EMAIL = 'team@spirara.com';

const Support = () => {
  return (
    <div className="min-h-screen bg-sand-100 font-body text-ink-900">
      <MarketingNav variant="light" current="/support" />

      <main className="mx-auto max-w-2xl px-5 py-16 sm:px-6 sm:py-24">
        <p className="text-xs uppercase tracking-[0.22em] text-saffron-600">Support</p>
        <h1 className="mt-3 font-display text-4xl font-light tracking-tight sm:text-5xl">
          How can we help?
        </h1>
        <p className="mt-4 text-base text-ink-700/80 sm:text-lg">
          For help with Spirara — bookings, your account, payments, or the mobile app — email our
          team. We typically reply within one to two business days.
        </p>

        <div className="mt-10 bg-sand-50 px-5 py-6 ring-1 ring-ink-900/10 sm:px-8 sm:py-8">
          <p className="text-xs font-semibold uppercase tracking-[0.14em] text-ink-700">
            Support email
          </p>
          <a
            href={`mailto:${SUPPORT_EMAIL}`}
            className="mt-3 inline-block font-display text-2xl font-light text-ink-900 underline decoration-saffron-500 decoration-2 underline-offset-4 transition-colors hover:text-ink-700 sm:text-3xl"
          >
            {SUPPORT_EMAIL}
          </a>
          <p className="mt-4 text-sm text-ink-600/70">
            Include your business name and the email on your Spirara account so we can help faster.
          </p>
        </div>

        <p className="mt-10 text-sm text-ink-600/70">
          Looking for something else?{' '}
          <Link to="/privacy-policy" className="underline decoration-ink-900/30 underline-offset-2 hover:text-ink-900">
            Privacy policy
          </Link>
          {' · '}
          <Link to="/delete-account" className="underline decoration-ink-900/30 underline-offset-2 hover:text-ink-900">
            Delete account
          </Link>
          {' · '}
          <Link to="/terms-of-service" className="underline decoration-ink-900/30 underline-offset-2 hover:text-ink-900">
            Terms of service
          </Link>
          {' · '}
          <Link to="/about" className="underline decoration-ink-900/30 underline-offset-2 hover:text-ink-900">
            About Spirara
          </Link>
        </p>
      </main>

      <footer className="border-t border-ink-900/10 bg-ink-950 py-10">
        <div className="mx-auto flex max-w-7xl flex-col gap-4 px-5 sm:flex-row sm:items-center sm:justify-between sm:px-6 lg:px-8">
          <span className="font-display text-2xl font-light text-sand-50">
            Spirara<span className="text-saffron-500">.</span>
          </span>
          <p className="text-xs text-sand-200/50">
            &copy; {new Date().getFullYear()} Spirara. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Support;
